import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle, Card, GhostButton } from "@/admin/ui";

export const LogsViewer = () => {
  const [logs, setLogs] = useState([]);
  const load = () => api.get("/admin/logs").then(({ data }) => setLogs(data));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-logs">
      <PageTitle title="Logs de Atividade" subtitle={`${logs.length} registros`}
        action={<GhostButton onClick={load}><RefreshCw className="w-4 h-4 inline mr-1" /> Atualizar</GhostButton>} />
      <Card className="!p-0 overflow-hidden">
        <div className="divide-y divide-white/[0.05] max-h-[75vh] overflow-y-auto">
          <div className="hidden md:grid grid-cols-[1fr_1.4fr_1.6fr_1.2fr] gap-4 px-5 py-3 text-[11px] uppercase tracking-wider text-white/40 bg-white/[0.02]">
            <span>Ação</span><span>Detalhe</span><span>Usuário</span><span>Data</span>
          </div>
          {logs.map((l) => (
            <div key={l.id} className="grid grid-cols-1 md:grid-cols-[1fr_1.4fr_1.6fr_1.2fr] gap-1 md:gap-4 px-5 py-3 text-sm hover:bg-white/[0.02]" data-testid="log-row">
              <span className="text-[#F5C542] font-medium">{l.action}</span>
              <span className="text-white/60">{l.detail || "—"}</span>
              <span className="text-white/50 text-xs md:text-sm">{l.email}</span>
              <span className="text-white/40 text-xs">{new Date(l.created_at).toLocaleString("pt-BR")}</span>
            </div>
          ))}
          {logs.length === 0 && <div className="p-8 text-center text-white/40">Sem logs.</div>}
        </div>
      </Card>
    </div>
  );
};
